import {
  AnnotationShape,
  LogoShape,
} from '@/web-components/import-wizard/typings/pintura';
import { ResolutionValue } from '../configuration';
import { ValidationResult, ValidatorResult } from '../index';

export const resolutionValidator =
  (validatorConfiguration: string, shape: LogoShape, printPositionId: string) =>
  ({ payload, validationResult }: ValidatorResult): ValidatorResult => {
    const validatorName = 'resolutionValidator';

    const resolutionColorsValues: ResolutionValue[] = JSON.parse(
      validatorConfiguration
    );
    const { pngHorizontalResolutionDPIs, pngVerticalResolutionDPIs } = shape;
    const lowerDPI =
      (pngHorizontalResolutionDPIs as number) <=
      (pngVerticalResolutionDPIs as number)
        ? (pngHorizontalResolutionDPIs as number)
        : (pngVerticalResolutionDPIs as number);

    const color: ResolutionValue = resolutionColorsValues.find((f) => {
      if (lowerDPI >= f.minDPI && lowerDPI <= f.maxDPI) {
        if (f.color === 'red') {
          f.color = 'Red';
        }
        if (f.color === 'orange') {
          f.color = 'Orange';
        }
        if (f.color === 'green') {
          f.color = 'Green';
        }

        return f;
      }

      if (
        (pngHorizontalResolutionDPIs as number) > f.maxDPI &&
        (pngVerticalResolutionDPIs as number) > f.maxDPI
      ) {
        return { ...f, color: 'Red' };
      }
    }) as ResolutionValue;
    payload.id = shape.id;
    payload.personalizationArtworkId = shape.personalizationArtworkId as string;
    payload.fileName = shape.fileName as string;
    payload.pngHorizontalResolutionDPIs = pngHorizontalResolutionDPIs as number;
    payload.pngVerticalResolutionDPIs = pngVerticalResolutionDPIs as number;

    return {
      payload,
      validationResult: validationResult.concat([
        {
          printPositionId: printPositionId,
          validatorName: validatorName,
          validatorColor: color?.color,
          message:
            resolutionColorsValues.find((x) => x.color === 'Green')?.minDPI ||
            300,
        },
      ]) as ValidationResult,
    };
  };
